module.exports = __webpack_public_path__ + "static/media/cash-multiple.d02ff224.svg";